import { render, staticRenderFns } from "./ActiveDeactivateButton.vue?vue&type=template&id=480452f4&"
import script from "./ActiveDeactivateButton.vue?vue&type=script&lang=js&"
export * from "./ActiveDeactivateButton.vue?vue&type=script&lang=js&"
import style0 from "./ActiveDeactivateButton.vue?vue&type=style&index=0&id=480452f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports